import React, { Component } from "react";
import Big from "big.js";
import { Row, Col } from "react-flexbox-grid";
import { nestedParameter } from "util";
import { FormattedNumber } from "react-intl";
import {
  CheckBox,
  DataTable,
  Loadable,
  IconButton,
  If,
  Link,
  StyledButton,
  EntitySelector
} from "components/support";

import Tooltip from "material-ui-next/Tooltip";
import Icon from "material-ui-next/Icon";
import Paper from "material-ui-next/Paper";
import Popover from "material-ui/Popover";
import Menu from "material-ui/Menu";
import MenuItem from "material-ui/MenuItem";

import style from "./style";
import { colors } from "assets";
import Modal from "./label-modal";
import BatchFiscalInformationsModal from "./batch-fiscal-informations-modal";

class DataTableView extends Component {
  state = {
    open: false
  };

  config = {
    identifier: "uuid",
    columns: [
      {
        accessor: "uuid",
        show: false
      },
      {
        id: "checkboxes",
        Header: () => (
          <CheckBox
            checked={this.allCheckBoxesSelected()}
            onCheck={checked => this.selectAllCheckBoxes(checked)}
            style={{ padding: 0, margin: "0px 0px 0px 5px" }}
            squareIconStyle={{ backgroundColor: "#FFFFFF", margin: 2 }}
            checkBoxStyle={{ border: "2px solid #FFFFFF" }}
          />
        ),
        Cell: props => (
          <CheckBox
            checked={this.props.viewModel.checkedProducts[props.original.uuid]}
            onCheck={checked =>
              this.props.presenter.onSingleCheckBoxEnqueue({
                [props.original.uuid]: checked
              })
            }
            style={{ padding: 0, margin: "0px 0px 0px 9px" }}
            checkBoxStyle={{ border: `1px solid ${colors.primary.normal}` }}
          />
        ),
        align: "center",
        sortable: false,
        width: 60
      },
      {
        id: "code",
        accessor: "code",
        Header: "Código",
        align: "center",
        Cell: props => this.parseField(props.row._original, "code")
      },
      {
        id: "name",
        accessor: "name",
        Header: "Nome",
        type: "custom",
        Cell: props => this.parseField(props.row._original, "name")
      },
      {
        id: "category",
        sortable: false,
        accessor: "category_name",
        Header: "Categoria",
        align: "center",
        Cell: props => this.parseField(props.row._original, "category_name")
      },
      {
        id: "stock_count",
        accessor: "stock_count",
        Header: "Estoque",
        align: "center",
        Cell: props => this.parseField(props.row._original, "stock_count")
      },
      {
        id: "sell_value",
        accessor: "sell_value",
        Header: "Preço de Venda",
        align: "center",
        Cell: props => this.parseMoneyField(props.row._original, "sell_value")
      },
      {
        id: "actions",
        Header: "Ações",
        align: "right",
        sortable: false,
        Cell: props => this.parseActionsField(props.row._original)
      }
    ]
  };

  parseField = (obj, field) => {
    if (obj.type === "product_kit") {
      obj.stock_count = "-";
    }

    return (
      <p className={!!obj.deleted ? "field-deleted" : ""}>
        {nestedParameter(obj, field)}
      </p>
    );
  };

  parseMoneyField = (obj, field) => (
    <div>
      <If test={!obj.sell_value}>
        <Tooltip
          key="tooltip-right"
          title="Adicione um preço de venda para este produto"
          placement="bottom"
        >
          <Icon style={{ color: "red" }}>warning</Icon>
        </Tooltip>
      </If>
      <If test={obj.sell_value}>
        <p className={!!obj.deleted ? "field-deleted" : ""}>
          <FormattedNumber
            value={Big(nestedParameter(obj, field) || 0).div(100)}
            format="BRL"
          />
        </p>
      </If>
    </div>
  );

  onPrintChanged(uuid, value) {
    this.setState(prevState => ({
      printPdf: {
        ...prevState.printPdf,
        [uuid]: value
      }
    }));
  }

  parseActionsField = product => {
    const { presenter, viewModel, hasManageSellable } = this.props;
    const { loading, visible, printPdf, printAmount } = viewModel || {};

    return (
      <div>
        <IconButton
          mini
          icon="print"
          onClick={() => presenter.onOpenModal(product.uuid)}
        />

        <Modal
          visible={visible[product.uuid] || false}
          product={product}
          printPdf={printPdf}
          loading={loading}
          printAmount={printAmount}
          setLoading={value => presenter.setLoading(value)}
          setPrintAmount={value => presenter.setPrintAmount(value)}
          resetPrintAmount={() => presenter.resetPrintAmount()}
          onClose={uuid => presenter.onCloseModal(uuid)}
          onPrintChanged={(uuid, value) =>
            presenter.onPrintChanged(uuid, value)
          }
        />

        <IconButton
          mini
          icon="search"
          onClick={() => presenter.onRequestView(product)}
        />

        {!product.deleted && hasManageSellable && (
          <span>
            <IconButton
              mini
              icon="mode_edit"
              onClick={() => presenter.onRequestEdit(product)}
            />
            <IconButton
              mini
              icon="delete"
              onClick={() => presenter.onRequestDelete(product)}
            />
          </span>
        )}

        {product.deleted && (
          <IconButton
            mini
            icon="restore"
            onClick={() => presenter.onRestore(product)}
          />
        )}
      </div>
    );
  };

  allCheckBoxesSelected = () => {
    const { checkedProducts, resultSet } = this.props.viewModel;
    if (!resultSet.length) {
      return false;
    }

    for (const product of resultSet) {
      if (!checkedProducts[product.uuid]) {
        return false;
      }
    }
    return true;
  };

  selectAllCheckBoxes = checked => {
    const { presenter, viewModel } = this.props;
    const { resultSet } = viewModel;
    let checkedProducts = resultSet.reduce(
      (acc, product) => ({ ...acc, [product.uuid]: checked }),
      {}
    );
    if (checked) {
      presenter.showSelectAllProductsButton(true);
    } else {
      presenter.showSelectAllProductsButton(false);
      checkedProducts = {};
    }
    presenter.onCheckBoxEnqueue(checkedProducts);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.filter !== this.props.filter) {
      nextProps.presenter.onFilterChange(nextProps.filter);
    }
  }

  handleDataTableChange = ({ field, value }) => {
    const { presenter } = this.props;
    presenter.onOrderChange(field, value);
  };

  handlePageChange = page => {
    const { presenter } = this.props;
    presenter.onPageChange(page + 1);
  };

  handleTouchTap = event => {
    this.setState({
      open: true,
      anchorEl: event.currentTarget
    });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  handleModifyAction = action => {
    this.handleRequestClose();
    this.props.presenter.handleModifyAction(action);
  };

  handleBatchCategory = action => {
    this.handleRequestClose();
    this.props.presenter.onHandleBatchCategoryDialog(action);
  };

  onSelectBatchCategory = category => {
    this.props.presenter.onSelectBatchCategory(category);
  };

  handleBatchFiscalInformations = action => {
    const { presenter } = this.props;
    this.handleRequestClose();
    action === "open"
      ? presenter.verifyCrt()
      : presenter.onHandleBatchFiscalInformationsDialog(action);
  };

  render() {
    const { className, presenter, viewModel, filter } = this.props;
    const {
      loading,
      resultSet,
      pagination,
      order,
      renderSelectAllButton,
      checkboxCount,
      allProductsSelected,
      categorySearchOptions,
      batchCategoryDialogOpen,
      batchFiscalInformationsDialogOpen
    } = viewModel;
    const { anchorEl, open } = this.state;
    const amountMessage =
      checkboxCount !== 1 ? "Produtos selecionados: " : "Produto selecionado: ";
    const canDelete =
      !filter.status || filter.status === "all" || filter.status === "active";
    const canRestore = filter.status === "all" || filter.status === "deleted";
    const canBatchCategory = !allProductsSelected && !canRestore;
    const canBatchFiscalInformations = !allProductsSelected && !canRestore;

    return (
      <div className={className}>
        <Row>
          <Col xs={6}>
            <If test={checkboxCount}>
              <StyledButton
                style={{
                  margin: "12px 0px 8px 0px",
                  backgroundColor: colors.primary.dark
                }}
                primary
                onClick={event => this.handleTouchTap(event)}
              >
                <Row middle="xs">
                  <Col xs={10} className="pr-0 text-left">
                    Ações em lote
                  </Col>
                  <Col xs={2} className="pr-0">
                    <Icon style={{ fontSize: 20, marginTop: 4 }}>
                      keyboard_arrow_down
                    </Icon>
                  </Col>
                </Row>
              </StyledButton>
            </If>

            <Popover
              open={open}
              anchorEl={anchorEl}
              onRequestClose={() => this.handleRequestClose()}
              anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
              targetOrigin={{ horizontal: "left", vertical: "top" }}
            >
              <Menu>
                <If test={canDelete}>
                  <MenuItem
                    primaryText="Excluir"
                    onClick={() => this.handleModifyAction("delete")}
                  />
                </If>
                <If test={canRestore}>
                  <MenuItem
                    primaryText="Restaurar"
                    onClick={() => this.handleModifyAction("restore")}
                  />
                </If>
                <If test={canBatchCategory}>
                  <MenuItem
                    primaryText="Trocar categoria"
                    onClick={() => this.handleBatchCategory("open")}
                  />
                </If>
                <If test={canBatchFiscalInformations}>
                  <MenuItem
                    primaryText="Trocar informações fiscais"
                    onClick={() => this.handleBatchFiscalInformations("open")}
                  />
                </If>
              </Menu>
            </Popover>
            <EntitySelector
              nullSelection={{ uuid: "", name: "" }}
              hideField
              open={batchCategoryDialogOpen}
              title="Selecionar Categoria"
              searchOptions={categorySearchOptions}
              onSelect={category => this.onSelectBatchCategory(category)}
              parser={category => ({
                key: category.uuid,
                title: category.name
              })}
              onClose={() => this.handleBatchCategory("close")}
              dummyItem={{
                uuid: null,
                name: "Remover categorias",
                delete: true
              }}
            />
          </Col>

          <Col className="mt-md text-left" xs>
            <h3 style={{ padding: 10, margin: 0 }}>
              {amountMessage}
              {checkboxCount}
            </h3>
          </Col>
          <Col className="mt-md text-right" xs>
            <h3 style={{ textAlign: "right", padding: 10, margin: 0 }}>
              Total de Produtos: {pagination.total}
            </h3>
          </Col>
        </Row>

        <If test={renderSelectAllButton && checkboxCount}>
          <Row middle="xs" center="xs" className="select-all-row mb-sm mt-sm">
            <Col xs={12}>
              <If test={!allProductsSelected}>
                Todos os <b>{checkboxCount}</b> produtos desta página foram
                selecionados.&nbsp;
                <Link
                  onClick={() => presenter.handleSelectAllButton()}
                  label={`Selecione todos os ${pagination.total} produtos da empresa.`}
                  className="bold-text"
                />
              </If>

              <If test={allProductsSelected}>
                Todos os <b>{checkboxCount}</b> produtos desta empresa foram
                selecionados.&nbsp;
                <Link
                  onClick={() => this.selectAllCheckBoxes(false)}
                  label={`Limpar seleção de produtos.`}
                  className="bold-text"
                />
              </If>
            </Col>
          </Row>
        </If>

        <Row className="full-width m-0">
          <Paper elevation={1} className="product__content full-width">
            <Loadable loading={loading}>
              <DataTable
                manual
                resultSet={resultSet}
                total={pagination.total}
                perPage={pagination.perPage}
                page={pagination.currentPage}
                config={this.config}
                onChange={this.handleDataTableChange}
                orderField={order.field}
                orderDirection={order.direction}
                onPageChange={this.handlePageChange}
              />
            </Loadable>
          </Paper>
        </Row>

        <BatchFiscalInformationsModal
          batchFiscalInformationsDialogOpen={batchFiscalInformationsDialogOpen}
          loading={loading}
          onClose={() => this.handleBatchFiscalInformations("close")}
          onSaveBatchFiscalInformations={fiscal_informations =>
            presenter.onSelectBatchFiscalInformations(fiscal_informations)
          }
        />
      </div>
    );
  }
}

export default style(DataTableView);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/list/data-table/view.jsx